import React, { memo } from 'react'

import { BffInterfacesDeparture } from '@dfds-pax/booking-experience-bff'

import DepartureTierGroupSingle from '../departure-tier/DepartureTierSingle'

interface DepartureHeaderProps {
  addDeparture: (ticket: BffInterfacesDeparture.Ticket) => void
  departureId: string
  highlight?: boolean
  loading: boolean
  offerApplied: boolean
  returnLeg?: boolean
  selected?: boolean
  selectionLoading: boolean
  selectedType?: string
  ticket: BffInterfacesDeparture.Ticket
}

const DepartureRowSelectionSingleTier = ({
  addDeparture,
  departureId,
  loading,
  offerApplied,
  returnLeg,
  selected,
  selectedType,
  selectionLoading,
  ticket,
}: DepartureHeaderProps): React.ReactElement => {
  return (
    <div className="p-semantic-global-md md:p-semantic-global-lg gap-semantic-global-md md:gap-semantic-global-lg flex flex-col">
      <DepartureTierGroupSingle
        departureId={departureId}
        loading={loading}
        offerApplied={offerApplied}
        onDepartureTierSelection={(ticket) => addDeparture(ticket)}
        returnLeg={returnLeg ?? false}
        selectionLoading={selectionLoading}
        selectedType={selected && selectedType ? selectedType : false}
        ticket={ticket}
      />
    </div>
  )
}

export default memo(DepartureRowSelectionSingleTier)
